import React, { FC, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import * as _ from 'lodash';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';

import AccountsPayableCustomTable from '@components/AccountsPayableCustomTable';
import useStore from '@hooks/useStore';

import { formattedAmount } from '@utils/format';
import useStyles from '@containers/AccountsPayable/styles';

export interface IAccountsPayableGroupCustomTables {
  canSelect?: boolean;
  toolBarTitle?: string;
  statusSuccessLabel?: string;
  hideEnhancedTableToolbar?: boolean;
  withSubtotals?: boolean;
  rows: any[];
}

const AccountsPayableGroupCustomTables: FC<IAccountsPayableGroupCustomTables> = ({
  canSelect = true,
  toolBarTitle = '',
  statusSuccessLabel,
  rows,
  hideEnhancedTableToolbar,
  withSubtotals = false,
}) => {
  const css = useStyles();
  const { accountsPayableLink } = useStore();
  const { tools, accountsPayable, fundInfo } = accountsPayableLink;
  const { toolsGroupBy } = tools;

  const [tableGroups, setTableGroups] = useState<any[]>([]);

  const unselectedIds = toJS(accountsPayable.unselectedIds);

  const totalGroups = [];
  if (tableGroups.length > 0 && unselectedIds) {
    let totalTransactions = 0;

    for (const group of tableGroups) {
      const { accountsPayable } = group;
      totalTransactions = totalTransactions + accountsPayable.length;
      let totalAmount = 0;
      for (const ap of accountsPayable) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const amount = ap.amount as any;
        const itemAmount = Number(amount);
        totalAmount = totalAmount + itemAmount;
      }

      let totalUnselectedAmount = 0;
      let totalUnselected = 0;
      for (const id of unselectedIds) {
        const ap = accountsPayable
          .map((item: any) => item.accountPayableId === id && Number(item.amount))
          .filter(Boolean) as number[];
        if (Object.keys(ap).length > 0) {
          totalUnselectedAmount = totalUnselectedAmount + ap[0];
          totalUnselected++;
        }
      }

      totalGroups.push({
        group: group.group,
        amount: totalAmount - totalUnselectedAmount,
        totalTransaction: accountsPayable.length - totalUnselected,
      });
    }
  }

  useEffect(() => {
    let key = toolsGroupBy as any;
    if (key === 'provider') {
      key = 'businessName';
    }
    const groups = _.groupBy(rows, key);
    const keys = Object.keys(groups);
    const values = Object.values(groups);
    const tableGroups = [];
    const emptyGroup = [];

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === '') {
        emptyGroup.push({
          group: 'Otros',
          accountsPayable: values[i],
          accountsPayableIds: values[i].map((item: any) => item.accountPayableId),
          totalAccountsPayable: values[i].length,
        });
      } else {
        const group = {
          group: keys[i],
          accountsPayable: values[i],
          accountsPayableIds: values[i].map((item: any) => item.accountPayableId),
          totalAccountsPayable: values[i].length,
        };
        tableGroups.push(group);
      }
    }

    setTableGroups([...tableGroups, ...emptyGroup]);
  }, [toolsGroupBy]);

  return (
    <>
      {tableGroups.map((item, index) => {
        return (
          <AccountsPayableCustomTable
            hideEnhancedTableToolbar={hideEnhancedTableToolbar}
            statusSuccessLabel={statusSuccessLabel}
            canSelect={canSelect}
            grouped
            group={item.group}
            rows={item.accountsPayable}
            toolBarTitle={toolBarTitle}
            groupedTotalRows={item.totalAccountsPayable}
            groupedRowsIds={item.accountsPayableIds}
            key={index}
          />
        );
      })}
      {withSubtotals && (
        <Grid container spacing={3} className={css.subTotalsGroupsContainer}>
          <Grid item xs={12} md={8} />
          <Grid item xs={12} md={4}>
            {totalGroups.map((item: any, index) => {
              return (
                <Grid key={index} container className={css.containerSubTotals}>
                  <Grid item xs={8} md={6}>
                    {item.group} <span className={css.rowsCounter}>{item.totalTransaction}</span>
                  </Grid>
                  <Grid item xs={4} md={6} className={css.subTotals}>
                    {formattedAmount(item.amount, fundInfo.currency)}{' '}
                    <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default observer(AccountsPayableGroupCustomTables);
